import {
  ApiIncrementalityTest,
  ApiIncrementalityTestPayload,
  ApiIncrementalityTestResult,
} from "@incendium/api";
import { incrementalityService } from "Apis";

export async function listIncrementalityTests(
  projectId: number,
): Promise<ApiIncrementalityTest[]> {
  const res = await incrementalityService.incrementalityServiceListTests({
    projectId,
  });
  return res.results || [];
}

export async function readIncrementalityTest(
  projectId: number,
  testId: number,
): Promise<ApiIncrementalityTest> {
  return incrementalityService.incrementalityServiceReadTest({
    projectId,
    testId,
  });
}

export async function createIncrementalityTest(
  projectId: number,
  payload: ApiIncrementalityTestPayload,
): Promise<ApiIncrementalityTest> {
  return incrementalityService.incrementalityServiceCreateTest({
    projectId,
    payload,
  });
}

export async function updateIncrementalityTest(
  projectId: number,
  testId: number,
  payload: ApiIncrementalityTestPayload,
): Promise<ApiIncrementalityTest> {
  return incrementalityService.incrementalityServiceUpdateTest({
    projectId,
    testId,
    payload,
  });
}

export async function deleteIncrementalityTest(
  projectId: number,
  testId: number,
): Promise<void> {
  await incrementalityService.incrementalityServiceDeleteTest({
    projectId,
    testId,
  });
}

export async function readIncrementalityResult(
  projectId: number,
  testId: number,
): Promise<ApiIncrementalityTestResult> {
  return incrementalityService.incrementalityServiceReadResult({
    projectId,
    testId,
  });
}
